import {Opportunity} from './types'

export const PHOTOGRAPHER_RESOURCE_CENTER_URL = 'https://www.airbnb.com/e/photographer-resource-center'

type GuidelineKey = 'lighting_tips' | 'composition_tips' | 'photo_uploading' | 'photo_styling' | 'homes_brief'

export const GUIDELINE_URLS: Record<GuidelineKey, string> = {
    lighting_tips: 'https://www.airbnb.com/e/photo-lighting-tips',
    composition_tips: 'https://www.airbnb.com/e/photo-composition-tips',
    photo_uploading: 'https://www.airbnb.com/e/photo-uploading',
    photo_styling: 'https://www.airbnb.com/e/photo-styling-tips',
    homes_brief: 'https://www.airbnb.com/e/homes-photo-brief'
}

export const ISSUE_TO_GUIDELINE: Record<Opportunity['keyName'], GuidelineKey | null> = {
    aperture_issue: 'lighting_tips',
    artificial_lighting: 'lighting_tips',
    bracket_merging_issue: 'photo_uploading',
    camera_height_issue: 'composition_tips',
    closed_shower_curtains: 'photo_styling',
    curtains_closed: 'lighting_tips',
    dirty_lens_sensor: 'lighting_tips',
    file_format: 'photo_uploading',
    flash: 'lighting_tips',
    focus_issues: 'lighting_tips',
    high_iso: 'lighting_tips',
    lens_is_too_tight: 'composition_tips',
    lens_is_too_wide: 'composition_tips',
    metering_issue: 'lighting_tips',
    missed_removal: 'homes_brief',
    no_lens_hood: 'lighting_tips',
    no_tripod_cell_phone: 'lighting_tips',
    shutter_speed_issue: 'lighting_tips',
    tilted_tripod: 'composition_tips',
    wide_tight_distortion: 'composition_tips'
}
